
export default {
  name: 'ConfirmationPopup',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    message() {
      return this.$i18n.locale === 'fr' ? 'Demande envoyée' : 'Request sended'
    }
  }
}
